<template>
    <div>
        <b-form-group>
            <label class="typo__label">{{ $t('forms.downtimetype') }}</label>
            <multiselect v-model="resetCheckTimeOptionSelected"
                         track-by="value"
                         :close-on-select="true"
                         :show-labels="false"
                         label="text"
                         placeholder="Select one"
                         :options="resetCheckTimeOptions"
                         :searchable="false"
                         :allow-empty="false">
            </multiselect>
        </b-form-group>
        <br>
        <b-button variant="success" class="w-100" v-on:click="sendResetCheckTime">{{
                $t('forms.send-command')
            }}
        </b-button>
    </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import { useToast } from "vue-toastification";

export default {
    name: "HostResetCheckTime",
    components: {Multiselect},
    data(){
        return {
            resetCheckTimeOptionSelected: {
                value: 'hostOnly',
                text: this.$t('hosts.individual')
            },
            resetCheckTimeOptions: [
                {
                    value: 'hostOnly',
                    text: this.$t('hosts.individual')
                },
                {
                    value: 'hostAndServices',
                    text: this.$t('hosts.including-services')
                }
            ],
        }
    },
    props: ['hostids'],
    methods: {
        sendResetCheckTime: function(){
            if(this.hostids.length === 0){
                useToast().error('no hosts selected', {
                    timeout: 2000
                });
                return;
            }
            let externalCommand = []
            for(let host in this.hostids){
                externalCommand.push({
                   // command: 'SCHEDULE_FORCED_HOST_CHECK',
                  //  hostUuid: this.hostids[host].hostUuid

                    command: 'rescheduleHost',
                    hostUuid: this.hostids[host].hostUuid,
                    satelliteId: this.hostids[host].satelliteId,
                    type: this.resetCheckTimeOptionSelected.value
                })
            }

            axios.post('/hosts/external_commands.json', externalCommand)
                .then(response => {
                        if(response.data.response.code && response.data.response.code === 403){
                            useToast().error('insufficient rights', {
                                timeout: 2000
                            });
                        }else{
                            useToast().success(this.$t('Command successfully sent'), {
                                timeout: 7000
                            });
                        }
                        this.$emit('refresh')
                })
                .catch(error => {
                    useToast().error(this.$t('error'), {
                        timeout: 2000
                    });
                });
        },
    },
    mounted(){
    },
}
</script>

<style scoped>

</style>
